import React, { useState, useEffect, useContext } from 'react';
import { FaCommentAlt } from 'react-icons/fa';
import axios from 'axios';
import AppContext from '../../context/AppContext';
import HotelReviewCard from '../../components/vendors/HotelReviewCards';
import '../../assets/css/vendors/HotelScreens/hotelReviews.css';
import VendorLayout from '../../layout/HotelVendorLayout/VendorLayout';

const HotelReviews = () => {
const { baseUrl, authToken, vendorId  } = useContext(AppContext);
const [reviews, setReviews] = useState([]);
const [loading, setLoading] = useState(true);

 useEffect(() => {
  if (!vendorId) return;
  setLoading(true);
  axios
    .get(`${baseUrl}/vendor/view-vendor-reviews`, {
      params: { vendor_id: vendorId },
      headers: { Authorization: `Bearer ${authToken}` },
    })
    .then((res) => {
      if (res.data.success) setReviews(res.data.data || []);
    })
    .catch(() => {})
    .finally(() => setLoading(false));
}, [baseUrl, authToken, vendorId]);
  const totalReviews = reviews.length;

  return (
    <VendorLayout>
    <div className="ven-rev-container">

      <div className="ven-rev-header">
        <h1>Hotel Reviews</h1>
        <p>Customer feedback for your property</p>
      </div>

      <div className="ven-rev-summary-card">
        <div className="ven-rev-summary-icon-wrap">
          <FaCommentAlt />
        </div>
        <div className="ven-rev-summary-info">
          <h2>{totalReviews}</h2>
          <p>Total Reviews</p>
        </div>
      </div>

      {loading ? (
        <p className="ven-rev-empty">Loading reviews…</p>
      ) : reviews.length === 0 ? (
        <p className="ven-rev-empty">No reviews found.</p>
      ) : (
        <div className="ven-rev-cards-grid">
          {reviews.map((review) => (
            <HotelReviewCard key={review.id} review={review} />
          ))}
        </div>
      )}

    </div>
    </VendorLayout>
  );
};

export default HotelReviews;